export default "__VITE_ASSET__B7Z4ATfo__"